import { Point } from '@flatten-js/core';

export class Coordinate {
  x = 0;
  y = 0;

  constructor(x, y) {
    if (Array.isArray(x) && x.length === 2) {
      this.x = x[0];
      this.y = x[1];
    } else {
      this.x = x || this.x;
      this.y = y || this.y;
    }
  }

  getFlattenPoint() {
    return new Point(this.x, this.y);
  }
}
